import axios from 'axios';
import Idx from 'idx';

const AxiosInstance = axios.create({
  // baseURL: `http://localhost:5001/livestock-dev-6f4fe/us-central1/api`,
  baseURL: `${process.env.REACT_APP_SERVER_URL}`,
  // baseURL: `http://3.143.221.219:5000/livestock-dev-6f4fe/us-central1/api`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  // milliseconds * seconds * minutes
  timeout: 1000 * 60 * 2,
});

// Add a request interceptor
AxiosInstance.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
);

// Add a response interceptor
AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (Idx(error, (_) => _.response.data)) {
      const errorDetail = {
        code: error.response.status,
        message: error.response.data.message,
      };

      return Promise.reject(errorDetail);
    }

    return Promise.reject(error);
  },
);

export default AxiosInstance;
